import React from 'react';
import style from '../../../styles/styles';
import PropTypes from 'prop-types';
import DoneIcon from 'material-ui/svg-icons/action/done';
import DeleteIcon from 'material-ui/svg-icons/action/delete-forever';
import moment from 'moment';
import CommentService from '../../../services/comment';
import AdminService, { ADMIN } from '../../../services/admin';
import {
    Avatar,
    Card,
    CardActions,
    CardHeader,
    CardText,
    CardTitle,
    FlatButton,
} from 'material-ui';
import withTranslation from '../../../hoc/withTranslation';

class Comment extends React.Component {

    static propTypes = {
        comment: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
        handleRejectComment: PropTypes.func,
        handleAcceptComment: PropTypes.func,
        handleDeleteComment: PropTypes.func,
    };

    // Handlers

    handleRemoveType = () => {
        this.props.handleRemoveType(this.props.type);
    };

    // Render

    renderActions() {
        const { comment } = this.props;

        if (!AdminService.isAuthorized(ADMIN, this.props.user)) {
            return null;
        }

        return (
            <CardActions>
                {this.props.handleRejectComment && (
                    <FlatButton
                        label={this.props.t('generic.reject')}
                        icon={<DeleteIcon />}
                        onClick={() => this.props.handleRejectComment(comment)}
                    />
                )}
                {this.props.handleDeleteComment && (
                    <FlatButton
                        label={this.props.t('generic.delete')}
                        icon={<DeleteIcon />}
                        onClick={() => this.props.handleDeleteComment(comment)}
                    />
                )}
                {this.props.handleAcceptComment && (
                    <FlatButton
                        label={this.props.t('generic.accept')}
                        icon={<DoneIcon />}
                        primary={true}
                        onClick={() => this.props.handleAcceptComment(comment)}
                    />
                )}
            </CardActions>
        );
    }

    render() {
        const { comment } = this.props;

        let zDepth = 1;
        let noteDisplay;
        let commentDisplay;

        if (this.props.zDepth !== undefined) {
            zDepth = this.props.zDepth;
        }

        if (comment.note) {
            noteDisplay = <div style={{ whiteSpace: 'pre-line' }}>Note : {comment.note}/5</div>;
        }

        if (comment.comment) {
            commentDisplay =
                <div style={{ whiteSpace: 'pre-line' }}>Commentaire : {comment.comment}</div>;
        }
        const title = comment.user !== null
            ? `${comment.user.firstname} ${comment.user.lastname}`
            : comment.user_name !== null ? comment.user_name : this.props.t('module.comment.anonymous');
        const subtitle = comment.user ? comment.user.username : null;
        return (
            <Card style={style.margin.bottom.small} zDepth={zDepth}>
                <CardHeader
                    title={title}
                    subtitle={subtitle}
                    avatar={comment.user && comment.user.picture ?
                        <Avatar src={comment.user.picture} size={40}
                                style={style.image.cover} /> : null}
                />
                <CardTitle
                    subtitle={
                        <span>
                            {this.props.t('module.comment.posted_format', {
                                date: moment.unix(comment.created_at).format('DD/MM/YYYY'),
                                time: moment.unix(comment.created_at).format('HH:mm:ss'),
                                name: CommentService.displayName(comment),
                            })}
                        </span>
                    }
                />
                <CardText>
                    {noteDisplay}
                    {commentDisplay}
                </CardText>
                {this.renderActions()}
            </Card>
        );
    }
}

export default withTranslation(Comment);



// WEBPACK FOOTER //
// src/components/comment/Comment/Comment.js